exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-box[data-v-604b83f7]{text-align:center}.search-box .title[data-v-604b83f7]{font-size:18px;color:#303133}.search-box .form[data-v-604b83f7]{margin-bottom:35px}.user-info[data-v-604b83f7]{text-align:center;line-height:40px;font-size:16px}.user-info span[data-v-604b83f7]{width:150px}.user-info .tips[data-v-604b83f7]{color:#f56c6c}.user-info .btn-enter[data-v-604b83f7]{margin-top:35px}", ""]);

// exports
